import { forwardRef } from "react"

import { Typography } from "@/components/ds/Typography"
import { cn } from "@/lib/utils"

interface DragDropZoneProps {
  children: React.ReactNode
  isDragOver: boolean
  isUploading: boolean
  onDragOver: (e: React.DragEvent) => void
  onDragLeave: (e: React.DragEvent) => void
  onDrop: (e: React.DragEvent) => void
  className?: string
  dragOverText?: string
  defaultText?: string
  uploadingText?: string
}

export const DragDropZone = forwardRef<HTMLDivElement, DragDropZoneProps>(
  (
    {
      children,
      isDragOver,
      isUploading,
      onDragOver,
      onDragLeave,
      onDrop,
      className,
      dragOverText = "Drop your file here",
      defaultText = "Drag and drop media file to upload",
      uploadingText = "Uploading file...",
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex h-full flex-col rounded-2xl border-2 border-dashed p-6 transition-colors duration-200",
          isDragOver ? "border-brand-primary bg-brand-primary/5" : "border-neutral-border",
          isUploading && "opacity-50",
          className,
        )}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <div className="flex flex-1 flex-col items-center justify-center space-y-4">
          <div className="text-center">
            <Typography
              variant="body1"
              className={cn("transition-colors duration-200", isDragOver ? "text-brand-primary" : "text-neutral-text")}
            >
              {isUploading ? uploadingText : isDragOver ? dragOverText : defaultText}
            </Typography>
          </div>
          {children}
        </div>
      </div>
    )
  },
)

DragDropZone.displayName = "DragDropZone"
